import React from "react";
import Input from "Components/input/Input";
import Button from "Components/button/Button";
import request from "../config";
import t from "Utils/translation";
import withFormState from "Components/withFormState";
import { lock } from "Icons/index";
import Checkbox from "Components/checkbox/Checkbox";
import { alertSuccess } from "Utils/alerts";
import WarningBanner from "Components/warningBanner/WarningBanner";
import cx from "classnames";
import s from "./loginForm.scss";

const initialFormData = {
  email_address: "",
  password: "",
};

class LoginForm extends React.Component {
  state = {};

  componentDidMount() {
    // this weird rAF is because 1password doesn't not
    // show up on the input if the autofocus is triggerd.
    requestAnimationFrame(() => this.emailInput.focus());
  }

  login = async (e) => {
    e.preventDefault();
    this.props.setFormLoading();
    const config = {
      method: "POST",
      url: "/users/login",
      data: this.props.formData,
    };

    try {
      const resp = await request(config);
      this.props.unsetFormLoading();
      this.props.setSession(resp.data.resources[0]);
      alertSuccess(t("alert.loginSuccess"));
    } catch (e) {
      console.log("response1", e.response);

      if (!e.response && e instanceof Error) {
        throw e;
      }

      console.log("response", e.response);

      if (e.response.status === 404) {
        this.props.setFormErrors({
          email_address: " ",
          password: " ",
        });
        this.props.unsetFormLoading();
        return;
      }
      if (e.response.status === 307) {
        this.props.unsetFormLoading();
        this.props.showOtpVerificationModal();
        return;
      }

      if (e.response.status === 422) {
        this.props.unsetFormLoading();
        this.props.setFormErrors({
          email_address: t("infoMsg.verify.emailAddress"),
          password: " ",
        });
        return;
      }

      if (e.response.status === 308) {
        this.props.unsetFormLoading();
        this.props.showFirstLoginModal(this.props.formData.email_address, this.props.formData.password);
        return;
      }
    }
  };

  handleRemember = (obj) => {
    this.props.setRememberDeviceValue(obj.remember_device);
    this.props.setFormFieldValue(obj);
  };

  render() {
    const { className, formData, setFormFieldValue, formErrors, isFormLoading, buttonSubmitColor, isVianova } =
      this.props;

    const hasErrors = formErrors.email_address || formErrors.password;

    return (
      <form className={cx(className, s.loginForm)} method="post" onSubmit={this.login}>
        <Input
          className={s.input}
          label={t("input.label.username")}
          placeholder={t("input.placeholder.username")}
          name="email_address"
          errors={formErrors.email_address}
          onChange={setFormFieldValue}
          value={formData.email_address}
          id="login-email"
          type="email"
          required
          ref={(el) => (this.emailInput = el)}
          noRequired
          autoComplete="on"
          isVianova={isVianova}
        />

        <Input
          className={s.input}
          label={t("input.label.password")}
          id="login-password"
          placeholder={t("input.placeholder.password")}
          name="password"
          type="password"
          errors={formErrors.password}
          onChange={setFormFieldValue}
          value={formData.password}
          required
          autoComplete="on"
          noRequired
          isVianova={isVianova}
        />

        <Checkbox
          className={cx({ [s.input]: !isVianova })}
          label={t("input.label.login.remeber")}
          name="remember_device"
          checked={this.state.remember_device}
          autoComplete="on"
          onChange={this.handleRemember}
          isVianova={isVianova}
        />

        <div className={s.wrapErrorMsg}>
          {hasErrors && (
            <WarningBanner fullWidth color="red" className="my-3" msg={t("errorMsg.notValid.loginCredentials")} />
          )}
        </div>

        <Button
          color={buttonSubmitColor}
          className={cx(s.btn, {
            [s.withMargin]: !isVianova,
            "uppercase text-base": isVianova,
          })}
          id="login"
          type="submit"
          loading={isFormLoading}
        >
          button.login
        </Button>
      </form>
    );
  }
}

//LoginForm.propTypes = propTypes;

export default withFormState(LoginForm, initialFormData);
